import { autoRegisterFeature } from '@store/features/factory';

import { notesFeature } from './store/feature';

autoRegisterFeature(notesFeature);

export * from './components/EditAllBox';
export * from './components/EditNoteTemplate';
export * from './components/NoteListRow';
export * from './components/NotesEmptyState';
export * from './components/NotesListContent';
export * from './components/NotesListPage';
export * from './components/VoiceInstructionInput';
export * from './hooks/useEditNoteWithContext';
export * from './hooks/useEditTemplateLabelExperiment';
export * from './hooks/useNotesList';
export * from './store';
export * from './types';
